module.exports = __webpack_public_path__ + "media/icons/wlasciciel-prywatna-white-5121b13a.png";